import CancelablePromise from 'mn-utils/CancelablePromise';

const {
  uploadDocument,
} = require('../../upload');

export function apiV2KycDocumentRemove(params) {
  // return apiRequest('/v2/kyc/document/remove', params);
}

export function apiKYCDocumentUpload(params): Promise<any> {
  return uploadDocument({
    ...params,
    uploadUrl: params.uploadUrl || '/f2c/v1/admin/upload-kyc-doc',
  });
}
